module.exports = __webpack_public_path__ + "img/Index5.e9261361.png";